var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ItemBase',{staticClass:"item-data",attrs:{"id":_vm.id}},[_c('TableList',{attrs:{"lender":_vm.lender}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }